import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { EmployeePerformanceRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddEmployeePerformanceForm from "./components/AddEmployeePerformanceForm";
import fields from "../json/EmployeePerformance.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import { Create, GetAllEmployees } from "adminApi/EmployeePerformanceApi/EmployeePerformance";

const AddEmployeePerformance = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // initialValues
    const initialValues = useMemo(() => {
        return formdata.reduce((acc, field) => {
            acc[field.name] = field.name === "number_of_star" ? 5 : field.name === "status" ? "pending" : "";
            return acc;
        }, {});
    }, [formdata]);

    // useFormChange
    const {
        values,
        errors,
        handleChange,
        setErrors
    } = useFormChange(initialValues, EmployeePerformanceRules);

    // Fetch Employees
    const { data: employees = [] } = useFetchAllData(GetAllEmployees);


    // form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create(formValues);
        },
        (vals) => {
            const err = validateForm(vals, EmployeePerformanceRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Performance Record Created Successfully"
    );

    return (
        <>
            {loadingSubmit && <Spinner isSpinner={true} />}
            <AddEmployeePerformanceForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                employees={employees}
            />
        </>
    );
};

export default AddEmployeePerformance;
